/**
 * Timetastic
 * SEO component
 * @see https://www.gatsbyjs.org/docs/add-seo-component/
 */
import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { StaticQuery, graphql } from "gatsby"

// JSX
function SEO({
  card,
  description,
  image,
  lang,
  meta,
  hrefLangs,
  title,
  useTitleTemplate,
  schemaMarkup,
}) {
  const url = typeof window !== "undefined" ? window.location.href : ""

  return (
    <StaticQuery
      query={detailsQuery}
      render={(data) => {
        const metaDescription =
          description || data.site.siteMetadata.description

        // Override titleTemplate (see README for details)
        const titleTemplate =
          useTitleTemplate === true
            ? `%s - ${data.site.siteMetadata.title}`
            : title

        return (
          <Helmet
            htmlAttributes={{
              lang,
            }}
            title={title}
            titleTemplate={titleTemplate}
            meta={[
              {
                name: `description`,
                content: metaDescription,
              },
              {
                name: `geo.placename`,
                content: `Manchester`,
              },
              {
                property: `og:url`,
                content: url,
              },
              {
                property: `og:title`,
                content: title,
              },
              {
                property: `og:description`,
                content: metaDescription,
              },
              {
                property: `og:type`,
                content: `website`,
              },
              {
                property: `og:image`,
                content: image || data.site.siteMetadata.image,
              },
              {
                name: `twitter:card`,
                content: card || `summary_large_image`,
              },
              {
                name: `twitter:creator`,
                content: data.site.siteMetadata.twitterUsername,
              },
              {
                name: `twitter:title`,
                content: title,
              },
              {
                name: `twitter:description`,
                content: metaDescription,
              },
              {
                name: `twitter:image`,
                content: image || data.site.siteMetadata.image,
              },
            ].concat(meta)}
          >
            {hrefLangs ? (
              <link rel="alternate" hrefLang="en" href={hrefLangs.EnHref} />
            ) : null}

            {hrefLangs ? (
              <link rel="alternate" hrefLang="en-GB" href={hrefLangs.UkHref} />
            ) : null}

            {hrefLangs ? (
              <link rel="alternate" hrefLang="en-US" href={hrefLangs.UsaHref} />
            ) : null}
            {schemaMarkup && (
              <script type="application/ld+json">
                {JSON.stringify(schemaMarkup)}
              </script>
            )}
          </Helmet>
        )
      }}
    />
  )
}

SEO.defaultProps = {
  image: ``,
  lang: `en`,
  meta: [],
  useTitleTemplate: true,
}

SEO.propTypes = {
  description: PropTypes.string,
  image: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.array,
  title: PropTypes.string.isRequired,
  useTitleTemplate: PropTypes.bool,
}

export default SEO

const detailsQuery = graphql`
  query DefaultSEOQuery {
    site {
      siteMetadata {
        title
        description
        author
        image
        siteUrl: url
      }
    }
  }
`
